import {BaseCachedService} from './Core/BaseCachedService';

class TaxLotService extends BaseCachedService {
    get Url() { return super.Url + "/taxLots"; }
}

export const service = new TaxLotService();

